import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import Paging from "../../component/Paging";
import request from '../../../utils/Request.utils';
import { ToastContainer, toast } from 'react-toastify';

const PaymentCompleteList = () => {
  const [payments, setPayments] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currPage, setCurrPage] = useState(1);
  const [totalCnt, setTotalCnt] = useState(0);
  const [loading, setLoading] = useState(true);
  // 검색
  const [searchQuery, setSearchQuery] = useState('');
  const [inputQuery, setInputQuery] = useState(''); // 입력 필드 상태

  // 상태
  const [payStatList, setPayStatList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('PAY02');

  const [searchStartDate, setSearchStartDate] = useState('');
  const [searchEndDate, setSearchEndDate] = useState('');


  const getPayStat = () => {
    let params = {};

    const successHandler = (response) => {
      if (response.messageCode === 200) {
        setPayStatList(response.data.data_list);
      } else {
        console.log("결제 상태정보를 불러올 수 없습니다.");
        toast.error("결제 상태정보를 불러올 수 없습니다.");
      }
    };
    const failHandler = (error) => {
      console.log(error);
    };

    request.get("/common/code/pay_stat", params, successHandler, failHandler);
  };

  const successHandler = useCallback((response) => {
    if (response.messageCode === 200) {
      setPayments(response.data.dataList);
      setTotalPages(response.data.tot_page);
      setTotalCnt(response.data.totalCnt);
      setLoading(false);
    } else {
      toast.error("결제 정보를 불러올 수 없습니다.");
      setLoading(false);
    }
  }, []);

  const errorHandler = useCallback((error) => {
    toast.error("데이터를 불러오는 중 오류가 발생했습니다.");
    setLoading(false);
  }, []);

  const fetchPayments = useCallback(() => {
    setLoading(true);
    const params = {
      curr_page: currPage,
      per_page: 10,
      sort_col: 'reg_dtm',
      sort_by: 'desc',
      pay_stat: selectedStatus === '전체' ? 'all' : selectedStatus,
      search_query: searchQuery,
      search_start_date: searchStartDate,
      search_end_date: searchEndDate,
    };
    request.get("/payments/list/admin", params, successHandler, errorHandler);
  }, [currPage, searchQuery, selectedStatus, searchStartDate, searchEndDate, successHandler, errorHandler]);

  useEffect(() => {
    fetchPayments();
  }, [fetchPayments, currPage]);

  useEffect(() => {
    getPayStat();
  }, []);

  const handlePageChange = (page) => {
    setCurrPage(page);
  };

  const handleSearch = () => {
    setSearchQuery(inputQuery);
  };

  const handleReset = () => {
    setInputQuery('');
    setSearchQuery('');
    setSearchStartDate('');
    setSearchEndDate('');
    setCurrPage(1);
    fetchPayments();
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  const handleDateRangeClick = (rangeType) => {
    const today = new Date();
    let start = new Date();
    let end = new Date();

    switch (rangeType) {
      case 'today':
        // start and end are already set to today
        break;
      case 'yesterday':
        start.setDate(today.getDate() - 1);
        end.setDate(today.getDate() - 1);
        break;
      case 'week':
        start.setDate(today.getDate() - 7);
        break;
      case 'month':
        start.setDate(1);
        break;
      default:
        break;
    }

    setSearchStartDate(start.toISOString().split('T')[0]);
    setSearchEndDate(end.toISOString().split('T')[0]);
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">결제실패 / 취소</h2>
      <div className="adm_com_pg_content">
        <div className="adm_com_board_list__top">
          <div className="adm_com_date_select">
            <span className="tit">결제일 : </span>
            <input
              type="date"
              className="adm_com_datepicker"
              value={searchStartDate}
              onChange={(e) => setSearchStartDate(e.target.value)}
            />
            <span className="divider"> ~ </span>
            <input
              type="date"
              className="adm_com_datepicker"
              value={searchEndDate}
              onChange={(e) => setSearchEndDate(e.target.value)}
            />
            <button className="adm_com_btn black" onClick={() => handleDateRangeClick('today')}>오늘</button>
            <button className="adm_com_btn gray" onClick={() => handleDateRangeClick('yesterday')}>어제</button>
            <button className="adm_com_btn gray" onClick={() => handleDateRangeClick('week')}>일주일</button>
            <button className="adm_com_btn gray" onClick={() => handleDateRangeClick('month')}>이번달</button>
          </div>
          <div className="adm_com_board_search">
            <div className="adm_com_input_wrap flex_row">
              <span className="tit">상세조회 : </span>
              <select className="select" value={selectedStatus} onChange={handleStatusChange}>
                <option value="전체">전체</option>
                {payStatList.map((title) => (
                  <option key={title.comm_code} value={title.comm_code}>
                    {title.code_nm}
                  </option>
                ))}
              </select>
            </div>
            <article className='search'>
              <input type="search"
                value={inputQuery}
                onChange={(e) => setInputQuery(e.target.value)}
                placeholder='검색할 내용을 입력해 주세요.'
                className="input s type_search"
              />
              <button className="adm_com_btn blue" onClick={handleSearch}>조회</button>
              <button className="adm_com_btn gray" onClick={handleReset}>초기화</button>
            </article>
          </div>
        </div>
        {loading ? <p>Loading...</p> : (
          <table className='adm_com_board_list'>
            <colgroup>
              <col width="3%" /><col width="7%" /><col width="8%" /><col width="8%" /><col width="20%" />
              <col width="8%" /><col width="8%" /><col width="8%" /><col width="8%" />
            </colgroup>
            <thead>
              <tr>
                <th>#</th>
                <th>결제번호</th>
                <th>사용자 ID</th>
                <th>결재일자</th>
                <th>결제상품</th>
                <th>결제금액</th>
                <th>결제일</th>
                <th>결제수단</th>
                <th>결제상태</th>
                <th>관리</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, index) => (
                <tr key={payment.pay_seq}>
                  <td>{totalCnt - ((currPage - 1) * 10 + index)}</td>
                  <td>{payment.order_no}</td>
                  <td>{payment.user_seq_al_user?.user_id}</td>
                  <td>{new Date(payment.pay_dtm).toLocaleDateString()}</td>
                  <td>{payment.goods_ty_comm_code?.code_nm_kr}</td>
                  <td>{payment.goods_amt?.toLocaleString()} 원</td>
                  <td>{new Date(payment.pay_dtm).toLocaleDateString()}</td>
                  <td>{payment.pay_method_comm_code?.code_nm_kr}</td>
                  <td>{payment.pay_stat_comm_code?.code_nm_kr}</td>
                  <td><Link to={`/Payment/History/View/${payment.pay_seq}`} className="adm_com_btn line blue">상세</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <Paging currentPage={currPage} totalPages={totalPages} onPageChange={handlePageChange} />
      </div>
      <ToastContainer />
    </main>
  );
};

export default PaymentCompleteList;
